module.exports = __webpack_public_path__ + "img/J13307.5550f626.png";